<span [matTooltip]="tooltip" class="tooltip-anchor">
  <mat-icon *ngIf="icon" [svgIcon]="icon" [style.color]="color" class="badge-icon"></mat-icon>
</span>
